import React from 'react';

import VkAuth from "react-vk-auth";

class AuthFromVK extends React.Component{
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <VkAuth apiId="7190006" className='btn btn-flat blue waves-effect waves-dark' callback={this.props.callback} >
                Войти через ВК
            </VkAuth>
        )
    }
}

export default AuthFromVK;